
const gtagID = 'G-TKH9C53KLF';

function attachGTAG() {
  const gtagScript = document.createElement('script');
  gtagScript.async =  true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagID}`;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(gtagScript, firstScript);
}

function setupGTAG () {
  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', gtagID);
  window.gtag = gtag;
}

export default function initGTAG () {
    /*
    if (host.indexOf('staging') === -1 && host.indexOf('testing') === -1) {
        attachGTAG();
        setupGTAG();
    }
    */
    attachGTAG();
    setupGTAG();
}